$(document).ready(function() {

    /* CHECKBOX-VALIDIERUNG Newsletter-Anmeldung oö.at - Achtung IDs Dev-Live anpassen! */

    // Deutsches Newsletteranmeldeformular
    if ($("#ttg_ooeform #tx-powermail-pi1_fieldset_602").length) {
        $("#uid1433_0").click(function() {
            if ($('#uid1433_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            } // if
        });

        $("#uid1493_0").click(function() {
            if ($('#uid1493_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            } // if
        });

        $("#uid1489_0").click(function() {
            if ($('#uid1489_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            } // if
        });

        $("#uid1434_0").click(function() {
            if ($('#uid1434_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            } // if
        });

        $("#uid1488_0").click(function() {
            if ($('#uid1488_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            } // if
        });

        $("#uid1436").click(function() {
            $("input#uid1436").removeClass('invalid');
        });

        $("#uid8756").click(function() {
            $("input#uid8756").removeClass('invalid');
        });

    } // if


    // Englisches Newsletteranmeldeformular
    if ($("#ttg_ooeform #tx-powermail-pi1_fieldset_665").length) {
        $("#uid1630_0").click(function() {
            if ($('#uid1630_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1631_0").click(function() {
            if ($('#uid1631_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1632_0").click(function() {
            if ($('#uid1632_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1633_0").click(function() {
            if ($('#uid1633_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1634_0").click(function() {
            if ($('#uid1634_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1638").click(function() {
            $("input#uid1638").removeClass('invalid');
        });

    } // if

    // Tschechisches Newsletteranmeldeformular
    if ($("#ttg_ooeform #tx-powermail-pi1_fieldset_678").length) {
        $("#uid1674_0").click(function() {
            if ($('#uid1674_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1675_0").click(function() {
            if ($('#uid1675_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1676_0").click(function() {
            if ($('#uid1676_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1677_0").click(function() {
            if ($('#uid1677_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1678_0").click(function() {
            if ($('#uid1678_0').prop('checked')) {
                newsletter_setAllCheckboxesValid();
            }
        });

        $("#uid1682").click(function() {
            $("input#uid1682").removeClass('invalid');
        });
    } // if

    // leere Eingabefeld wenn Standardwert
    $('#ttg_ooeform input, #ttg_ooeform textarea').focus(function() {
        if ($(this).val() == $(this).attr('title')) {
            $(this).val('');
        } // if
    });

    // fülle Eingabefeld mit Standardwert wenn keine Eingabe
    $('#ttg_ooeform input, #ttg_ooeform textarea').blur(function() {
        if (!$(this).val()) {
            $(this).val($(this).attr('title'));
        } // if
    });

    $("#ttg_ooeform").submit(function() {

        // Überprüfung ob eine E-Mail Adresse eingegeben worden ist
        $('#ttg_ooeform input[type=email]').each(function() {
            if ($(this).val() == $(this).attr('title')) {

                var emailaddress2 = $(this).val();

                if (!isValidEmailAddress(emailaddress2)) {
                    $(this).addClass('invalid');
                } // if

            } // if
        });

        // Check Fields
        if ($(this).find('.invalid').length) {
            return false;
        } // if

        // Deutsches Newsletteranmeldeformular
        if ($("#ttg_ooeform #tx-powermail-pi1_fieldset_602").length) {

            if (!$("input#uid1436").val()) {
                $("input#uid1436").addClass('invalid');
            } // if

            if ($('#uid1433_0').prop('checked') || $('#uid1493_0').prop('checked') || $('#uid1489_0').prop('checked') || $('#uid1434_0').prop('checked') || $('#uid1488_0').prop('checked') || $('#uid8756_0').prop('checked')) {
                $('.powermail_check_inner_uid1433_0').removeClass('invalid');
                $('.powermail_check_inner_uid1493_0').removeClass('invalid');
                $('.powermail_check_inner_uid1489_0').removeClass('invalid');
                $('.powermail_check_inner_uid1434_0').removeClass('invalid');
                $('.powermail_check_inner_uid1488_0').removeClass('invalid');
            } else {
                $('.powermail_check_inner_uid1433_0').addClass('invalid');
                $('.powermail_check_inner_uid1493_0').addClass('invalid');
                $('.powermail_check_inner_uid1489_0').addClass('invalid');
                $('.powermail_check_inner_uid1434_0').addClass('invalid');
                $('.powermail_check_inner_uid1488_0').addClass('invalid');
                return false;
            } // if-else

        } // if

        // Englisches Newsletteranmeldeformular
        if ($("#ttg_ooeform #tx-powermail-pi1_fieldset_665").length) {

            if (!$("input#uid1638").val()) {
                $("input#uid1638").addClass('invalid');
            } else {
                $("input#uid1638").removeClass('invalid');
            } // if-else

            if ($('#uid1630_0').prop('checked') || $('#uid1631_0').prop('checked') || $('#uid1632_0').prop('checked') || $('#uid1633_0').prop('checked') || $('#uid1634_0').prop('checked') || $('#uid8757_0').prop('checked')) {
                $('.powermail_check_inner_uid1630_0').removeClass('invalid');
                $('.powermail_check_inner_uid1631_0').removeClass('invalid');
                $('.powermail_check_inner_uid1632_0').removeClass('invalid');
                $('.powermail_check_inner_uid1633_0').removeClass('invalid');
                $('.powermail_check_inner_uid1634_0').removeClass('invalid');
            } else {
                $('.powermail_check_inner_uid1630_0').addClass('invalid');
                $('.powermail_check_inner_uid1631_0').addClass('invalid');
                $('.powermail_check_inner_uid1632_0').addClass('invalid');
                $('.powermail_check_inner_uid1633_0').addClass('invalid');
                $('.powermail_check_inner_uid1634_0').addClass('invalid');
                return false;
            } // if-else
        } // if

        // Tschechisches Newsletteranmeldeformular
        if ($("#ttg_ooeform #tx-powermail-pi1_fieldset_678").length) {

            if (!$("input#uid1682").val()) {
                $("input#uid1682").addClass('invalid');
            } else {
                $("input#uid1682").removeClass('invalid');
            } // if-else

            if ($('#uid1674_0').prop('checked') || $('#uid1675_0').prop('checked') || $('#uid1676_0').prop('checked') || $('#uid1677_0').prop('checked') || $('#uid1678_0').prop('checked') || $('#uid8758_0').prop('checked')) {
                $('.powermail_check_inner_uid1674_0').removeClass('invalid');
                $('.powermail_check_inner_uid1675_0').removeClass('invalid');
                $('.powermail_check_inner_uid1676_0').removeClass('invalid');
                $('.powermail_check_inner_uid1677_0').removeClass('invalid');
                $('.powermail_check_inner_uid1678_0').removeClass('invalid');
            } else {
                $('.powermail_check_inner_uid1674_0').addClass('invalid');
                $('.powermail_check_inner_uid1675_0').addClass('invalid');
                $('.powermail_check_inner_uid1676_0').addClass('invalid');
                $('.powermail_check_inner_uid1677_0').addClass('invalid');
                $('.powermail_check_inner_uid1678_0').addClass('invalid');
                return false;
            } // if-else
        } // if

        if ($(this).find('.invalid').length) {
            return false;
        }
    });

    // melaande - 21.4.2015 - auskommentiert, da vermutlich nicht mehr benotigt
    // /* NL TOOL */
    // if( $("a.checkNL").length ){
    // $("a.checkNL").click(function() {
    // if( $(this).hasClass("checked") ){
    // $(this).removeClass("checked");
    // $(this).next("input").removeAttr("checked");
    // } else {
    // $(this).addClass("checked");
    // $(this).next("input").attr("checked","checked");
    // } // if-else
    // });
    // } // if

});

function newsletter_setAllCheckboxesValid() {
    //DE
    $('.powermail_check_inner_uid1433_0').removeClass('invalid');
    $('.powermail_check_inner_uid1493_0').removeClass('invalid');
    $('.powermail_check_inner_uid1489_0').removeClass('invalid');
    $('.powermail_check_inner_uid1434_0').removeClass('invalid');
    $('.powermail_check_inner_uid1488_0').removeClass('invalid');
    $('.powermail_check_inner_uid8756_0').removeClass('invalid');

    //EN
    $('.powermail_check_inner_uid1630_0').removeClass('invalid');
    $('.powermail_check_inner_uid1631_0').removeClass('invalid');
    $('.powermail_check_inner_uid1632_0').removeClass('invalid');
    $('.powermail_check_inner_uid1633_0').removeClass('invalid');
    $('.powermail_check_inner_uid1634_0').removeClass('invalid');
    $('.powermail_check_inner_uid8757_0').removeClass('invalid');

    //CZ
    $('.powermail_check_inner_uid1674_0').removeClass('invalid');
    $('.powermail_check_inner_uid1675_0').removeClass('invalid');
    $('.powermail_check_inner_uid1676_0').removeClass('invalid');
    $('.powermail_check_inner_uid1677_0').removeClass('invalid');
    $('.powermail_check_inner_uid1678_0').removeClass('invalid');
    $('.powermail_check_inner_uid8758_0').removeClass('invalid');
}

function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}